<ng-container *ngIf="{
    isMigrationAvailable: isMigrationAvailable$ | async,
    migrationDetails: migrationDetails$ | async,
  } as resolved">
  <div class="fx-col fx-center my-3 max-w-150 d-block mx-auto">
    <img
      src="blocks-assets/images/migration.svg"
      class="s-20 mt-3 mx-auto">

    <div class="radius-4 my-6 mx-3 px-3 bg-coolgrey fx-align-content-center fx-center text-justify pos-rel text-grey-400">
      <div class="text-bold body-1 pos-abs migration-title bg-white px-2 radious-4">
        {{ labels.requestMigration }}
      </div>
      <p class="text-left text-400 text-justify mt-5 mb-2 body-2">
        {{ labels.description }}
      </p>
    </div>

    <form
      *ngIf="resolved.isMigrationAvailable; else migrationNotAvailable"
      #browserCertifiedOperator="ngForm"
      class="mt-6 migration-form w-full"
      (ngSubmit)="migrationRequest(browserCertifiedOperator)">

      <!-- SUNFLOWER EMAIL -->
      <mat-form-field
        appearance="fill"
        class="custom-mat-form-field w-full custom-border-bottom">
        <input
          #emailSunflower="ngModel"
          matInput
          name="emailSunflower"
          placeholder="{{ labels.email }}"
          required
          emailSunflower
          ngModel>
        <mat-error
          *ngIf="(emailSunflower.dirty || emailSunflower.touched) && emailSunflower.errors?.required"
          class="text-red-500 body-3 ml-1 pos-abs">
          {{ labels.emailRequired }}
        </mat-error>
        <mat-error
          *ngIf="(emailSunflower.dirty || emailSunflower.touched) && emailSunflower.errors?.email"
          class="text-red-500 body-3 ml-1 pos-abs">
          {{ labels.emailInvalid }}
        </mat-error>
        <button
          mat-icon-button
          matSuffix
          (click)="emailSunflower.reset()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!-- SUNFLOWER PASSWORD -->
      <mat-form-field
        *ngIf="{ value: false } as showPassword"
        appearance="fill"
        class="custom-mat-form-field w-full custom-border-bottom">
        <input
          #passwordSunflower="ngModel"
          matInput
          name="passwordSunflower"
          placeholder="{{ labels.password }}"
          required
          ngModel
          [type]="showPassword.value ? 'text' : 'password'">
        <mat-error
          *ngIf="passwordSunflower.errors?.required"
          class="text-red-500 body-3 ml-1 pos-abs">
          {{ labels.passwordRequired }}
        </mat-error>
        <div
          mat-icon-button
          matSuffix
          class="fx-row">
          <button
            type="button"
            (click)="showPassword.value = !showPassword.value">
            <mat-icon>
              {{ showPassword.value ? 'visibility' : 'visibility_off' }}
            </mat-icon>
          </button>
          <button
            type="button"
            (click)="passwordSunflower.reset()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-form-field>

      <button
        class="custom-mat-button-primary"
        mat-button
        type="submit"
        [disabled]="browserCertifiedOperator.invalid || browserCertifiedOperator.pending">
        {{ labels.confirm }}
      </button>
    </form>


    <ng-template #migrationNotAvailable>
      <section
        *ngIf="resolved.isMigrationAvailable === false; else migrationSkeleton"
        class="mt-6 w-full fx-col fx-gap-3">
        <ng-container *ngIf="resolved.migrationDetails?.migration?.status !== 'migrated'">
          <ng-container *ngTemplateOutlet="attribute; context: {
              name: labels.migrationStatus,
              value: resolved.migrationDetails?.migration?.status | apply: toLabel
            }">
          </ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="attribute; context: {
            name: labels.email,
            value: resolved.migrationDetails?.migration?.email,
            copy: true
          }">
        </ng-container>


        <ng-container *ngIf="resolved.migrationDetails?.migration?.status === 'migrated' || resolved.migrationDetails?.migration?.status === 'error'">
          <section class="border-1 fx-align-center fx-row fx-gap-3 p-3 radius-4 radius-2 border-grey-100">
            <mat-icon class="text-grey-400 d-contents">
              info
            </mat-icon>
            <customer-title-content
              class="fx-g-1"
              [title]="labels.manageMigrationTitle">
            </customer-title-content>
            <button
              class="custom-mat-button-primary p-8 tw-bg-green-400"
              mat-button
              [disabled]="resolved.migrationDetails?.migration?.status !== 'migrated'"
              (click)="manageMigration.emit()">
              {{ labels.manageMigration }}
            </button>
          </section>

          <section class="border-1 fx-align-center fx-row fx-gap-3 p-3 radius-4 radius-2 border-grey-100">
            <mat-icon class="text-grey-400 d-contents">
              info
            </mat-icon>
            <customer-title-content
              class="fx-g-1"
              [title]="labels.pushToCompleteTitle"
              [content]="labels.pushToCompleteDescription">
            </customer-title-content>
            <button
              class="custom-mat-button-primary ml-0 p-8"
              mat-button
              (click)="resolved.migrationDetails?.migration?.firstDocId && completeMigration(resolved.migrationDetails?.migration?.firstDocId)">
              {{ labels.complete }}
            </button>
          </section>
        </ng-container>
      </section>

      <ng-template #migrationSkeleton>
        <div class="mt-6 migration-form w-full">
          <ion-skeleton-text
            animated
            class="custom-mat-form-field w-full custom-border-bottom h-9 radious-4">
          </ion-skeleton-text>

          <ion-skeleton-text
            animated
            class="custom-mat-form-field w-full custom-border-bottom h-9 radious-4">
          </ion-skeleton-text>

          <button
            class="custom-mat-button-primary"
            mat-button>
            <ion-skeleton-text
              class="custom-mat-form-field w-full custom-border-bottom h-6 radious-4 min-w-20"
              animated>
            </ion-skeleton-text>
          </button>
        </div>
      </ng-template>
    </ng-template>
  </div>
</ng-container>

<ng-template
  #attribute
  let-name="name"
  let-copy="copy"
  let-value="value">
  <div class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
    <div class="tw-text-sm tw-font-medium text-grey-300">
      {{ name }}
    </div>
    <ngx-copy-to-clipboard *ngIf="copy; else withOutCopy"
      class="tw-text-base tw-font-normal text-grey-400 ml-auto"
      position="right"
      copiedTooltip="Copied"
      [textToCopy]="value?.toString()">
      <div class="tw-text-base tw-font-normal text-grey-400 ml-auto">
        {{ value }}
      </div>
    </ngx-copy-to-clipboard>
    <ng-template #withOutCopy>
      <div class="tw-text-base tw-font-normal text-grey-400 ml-auto">
        {{ value }}
      </div>
    </ng-template>
  </div>
</ng-template>
